import Vue from 'vue'
import Router from 'vue-router'

// import Login from './components/Login.vue'
const Login = () => import(/* webpackChunkName: "login_home_welcome" */ './components/Login.vue')
// import Home from './components/Home.vue'
const Home = () => import(/* webpackChunkName: "login_home_welcome" */ './components/Home.vue')
// import Welcome from './components/Welcome.vue'
const Welcome = () => import(/* webpackChunkName: "login_home_welcome" */ './components/Welcome.vue')

// import Users from './components/user/Users.vue'
const Users = () => import(/* webpackChunkName: "users_rights_roles" */ './components/user/Users.vue')
// import Rights from './components/power/Rights.vue'
const Rights = () => import(/* webpackChunkName: "users_rights_roles" */ './components/power/Rights.vue')
// import Roles from './components/power/Roles.vue'
const Roles = () => import(/* webpackChunkName: "users_rights_roles" */ './components/power/Roles.vue')

// import Categories from './components/goods/Categories.vue'
const Categories = () => import(/* webpackChunkName: "categories_params" */ './components/goods/Categories.vue')
// import Params from './components/goods/Params.vue'
const Params = () => import(/* webpackChunkName: "categories_params" */ './components/goods/Params.vue')

// import Goods from './components/goods/Goods.vue'
const Goods = () => import(/* webpackChunkName: "goods_add" */ './components/goods/Goods.vue')
// import Add from './components/goods/Add.vue'
const Add = () => import(/* webpackChunkName: "goods_add" */ './components/goods/Add.vue')

// import Orders from './components/order/Orders.vue'
const Orders = () => import(/* webpackChunkName: "orders_reports" */ './components/order/Orders.vue')
// import Reports from './components/reports/Reports.vue'
const Reports = () => import(/* webpackChunkName: "orders_reports" */ './components/reports/Reports.vue')

Vue.use(Router)

const router = new Router({
  routes: [
    { path: '/', redirect: '/login' },
    { path: '/login', component: Login },
    {
      path: '/home',
      component: Home,
      // 路由重定向
      redirect: '/welcome',
      // 子路由规则
      children: [
        { path: '/welcome', component: Welcome },
        { path: '/users', component: Users },
        { path: '/roles', component: Roles },
        { path: '/rights', component: Rights },
        { path: '/categories', component: Categories },
        { path: '/params', component: Params },
        { path: '/goods', component: Goods },
        { path: '/goods/add', component: Add },
        { path: '/orders', component: Orders },
        { path: '/reports', component: Reports }
      ]
    }
  ]
})

// 挂载路由导航守卫
router.beforeEach((to, from, next) => {
  // to 将要访问的路径
  // from 代表从那个路径跳转而来
  // next 是一个函数，表示放行
  // next() 放行 next('/login') 强制跳转

  if (to.path === '/login') return next()
  // 获取token
  const tokenStr = window.sessionStorage.getItem('token')
  if (!tokenStr) return next('/login')
  next()
})

export default router
